import type { PropsWithChildren } from 'react'
import { LosseLayout } from '@ubo/losse-sjedel'
import Footer from './Footer'
import Header from './Header/Header'

export default function Layout({ children }: PropsWithChildren<{}>) {
  return (
    <LosseLayout>
      <Header />
      <main className="min-h-screen-dynamic bg-site-accent-light pt-[100px]">{children}</main>
      <Footer />
    </LosseLayout>
  )
}
